import { Redirect, useLocation } from "react-router-dom";
import { AuthState } from "@aws-amplify/ui-components";
import AmplifyAuth from "../components/AmplifyAuth";
import { useAuth } from "../hooks/useAuth";
import { HOME } from "../constants/routes";

const Login = () => {
  const location = useLocation();
  const auth = useAuth();

  return auth.authState === AuthState.SignedIn && auth.user ? (
    <Redirect to={location.state ? location.state.from.pathname : HOME} />
  ) : (
    <div className="login">
      <AmplifyAuth />
    </div>
  );
};

export default Login;
